import React, { useState } from "react";

const accordionItems = [
  { title: "Powerful Networking Platform ", content: "Connect with a diverse group of professionals, entrepreneurs, and business leaders through structured weekly meetings designed to foster long-term relationships." },
  { title: "Expert Insights & Learning", content: "Gain valuable knowledge from industry experts and mentors, helping you refine your business strategies and stay ahead of market trends." },
  { title: "Collaborative Growth Opportunities", content: "Engage in partnerships, referrals, and joint ventures with like-minded professionals, creating new avenues for business expansion." },
];

function Accordion() {
  const [openIndex, setOpenIndex] = useState(null); // Track which section is open

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Close if same, open new if different
  };
  return (
    <>
      {accordionItems?.map((items, index) => {
        return (
          <div key={index}>
          <div>

            <button
              className="flex justify-between w-full py-[21px] text-left px-[31px] md:text-[20px] text-[14px] font-[500] text-[#00725d] border border-[#00725d] rounded-[20px] transition-all duration-200"
              onClick={() => toggleAccordion(index)}
            >
              {items?.title}
              <img
                src="/assets/home/down.svg"
                alt="down"
                className={`w-[15px] h-[24px] transition-transform ${
                  openIndex === index ? "rotate-90" : ""
                }`}
              />
            </button>
            <div
              className={`overflow-hidden transition-max-height duration-300 ${
                openIndex === index ? "max-h-40" : "max-h-0"
              }`}
            >
            <div className=" py-[20px] px-[10px] rounded-md">
              {openIndex === index && <p className="text-[#00725d]">{items.content}</p>}
            </div>
            </div>
          </div>
          </div>
        );
      })}
    </>
  );
}

export default Accordion;
